import PropTypes from 'prop-types';

const accountShape = PropTypes.shape({
  accountId: PropTypes.string.isRequired,
  email: PropTypes.arrayOf(PropTypes.string),
  givenName: PropTypes.string,
  familyName: PropTypes.string,
  roles: PropTypes.arrayOf(PropTypes.string),
  honorificPrefix: PropTypes.string,
  avatarSmall: PropTypes.string,
});

const accountSummaryShape = PropTypes.shape({
  accountId: PropTypes.string.isRequired,
  subscriptionId: PropTypes.string,
  givenName: PropTypes.string,
  familyName: PropTypes.string,
  primaryEmail: PropTypes.string,
  avatarSmall: PropTypes.string,
});

export {
  accountShape,
  accountSummaryShape,
};
